import type { CashDenominationRowDto } from './cash-denominations.dto.js';
import type { CashOperationIdentityDto } from './cash-operation-identity.dto.js';

export const cashLocalTransferKindValues = [
  'drawer_refill',
  'drawer_drop',
  'drawer_to_drawer',
] as const;
export type CashLocalTransferKind = (typeof cashLocalTransferKindValues)[number];

export const cashLocalTransferStatusValues = ['applied', 'reversed'] as const;
export type CashLocalTransferStatus = (typeof cashLocalTransferStatusValues)[number];

export interface CashLocalTransferDto extends CashOperationIdentityDto {
  id: string;
  kind: CashLocalTransferKind;
  status: CashLocalTransferStatus;
  storeId: string;
  locationId: string;
  stationId: string;
  sourceCashLocationId: string;
  sourceCashSessionId: string | null;
  destinationCashLocationId: string;
  destinationCashSessionId: string | null;
  amountMinor: number;
  note: string | null;
  denominations: CashDenominationRowDto[] | null;
  sourceMovementId: string;
  destinationMovementId: string;
  cashNeededRequestId: string | null;
  reversedByCashTransferId: string | null;
  reversesCashTransferId: string | null;
  replacesCashTransferId: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CashLocalTransferCorrectionDto extends CashOperationIdentityDto {
  id: string;
  storeId: string;
  locationId: string;
  stationId: string;
  originalCashTransferId: string;
  actualAmountMinor: number;
  reason: string;
  createdAt: string;
  updatedAt: string;
}

export interface ListCashLocalTransfersRequest {
  companyId: string;
  locationId?: string;
  kind?: CashLocalTransferKind;
  status?: CashLocalTransferStatus;
}

export interface ListCashLocalTransfersResponse {
  items: CashLocalTransferDto[];
}

export interface PerformCashLocalTransferRequest {
  companyId: string;
  operationId: string;
  kind: CashLocalTransferKind;
  storeId: string;
  locationId: string;
  stationId: string;
  sourceCashLocationId: string;
  sourceCashSessionId?: string | null;
  destinationCashLocationId: string;
  destinationCashSessionId?: string | null;
  amountMinor: number;
  note?: string | null;
  denominations?: CashDenominationRowDto[] | null;
  cashNeededRequestId?: string | null;
  occurredAt?: string;
}

export interface ReverseCashLocalTransferRequest {
  companyId: string;
  operationId: string;
  cashTransferId: string;
  reason: string;
  denominations?: CashDenominationRowDto[] | null;
  occurredAt?: string;
}

export interface ReplaceCashLocalTransferRequest {
  companyId: string;
  operationId: string;
  cashTransferId: string;
  replacementAmountMinor: number;
  note?: string | null;
  denominations?: CashDenominationRowDto[] | null;
  occurredAt?: string;
}

export interface RecordCashLocalTransferCorrectionRequest {
  companyId: string;
  operationId: string;
  originalCashTransferId: string;
  storeId: string;
  locationId: string;
  stationId: string;
  actualAmountMinor: number;
  reason: string;
  occurredAt?: string;
}

export interface ListCashLocalTransferCorrectionsRequest {
  companyId: string;
  locationId?: string;
  originalCashTransferId?: string;
}

export interface ListCashLocalTransferCorrectionsResponse {
  items: CashLocalTransferCorrectionDto[];
}
